import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const BrandContext = createContext(null);

export function BrandProvider({ children }) {
  const { user } = useAuth();
  const [brands, setBrands] = useState([]);
  const [selectedBrandId, setSelectedBrandId] = useState(
    () => localStorage.getItem("mio.brand_id") || ""
  );

  const loadBrands = useCallback(async () => {
    if (!user || user === false) {
      setBrands([]);
      return;
    }
    try {
      const { data } = await api.get("/brands");
      setBrands(data || []);
      const stored = localStorage.getItem("mio.brand_id");
      const stillValid = data?.some((b) => b.id === stored);
      if (!stillValid && data?.length) {
        setSelectedBrandId(data[0].id);
        localStorage.setItem("mio.brand_id", data[0].id);
      }
    } catch {
      setBrands([]);
    }
  }, [user]);

  useEffect(() => {
    loadBrands();
  }, [loadBrands]);

  const selectBrand = (id) => {
    setSelectedBrandId(id);
    localStorage.setItem("mio.brand_id", id);
  };

  const selectedBrand = brands.find((b) => b.id === selectedBrandId);

  return (
    <BrandContext.Provider
      value={{ brands, selectedBrandId, selectBrand, selectedBrand, refreshBrands: loadBrands }}
    >
      {children}
    </BrandContext.Provider>
  );
}

export function useBrands() {
  const ctx = useContext(BrandContext);
  if (!ctx) throw new Error("useBrands must be used within BrandProvider");
  return ctx;
}
